<div class="sidePanelNewSiteButton" (click)="goToNewSitePage()">
  <div
    class="sidePanelNewSiteButton__inner"
    data-testid="side-panel-new-site-button-label"
  >
    <pp-icon
      data-testid="side-panel-new-site-button-icon"
      [ppSVG]="iconMap[iconPath]"
      ppColor="inherit"
      ppClass="setSize16"
    />

    {{ 'new_site' | ppTranslate }}
  </div>
</div>
